<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Voeg een nieuwe Stage toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewStageDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-1" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddStageForm" lazy-validation>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Naam"
          v-model.trim="newStage.name"
          autocomplete
          prepend-icon="account_box"
          background-color="background"
          required
        ></v-text-field>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Omschrijving"
          v-model.trim="newStage.description"
          autocomplete
          hint="Vul een korte omschrijving in van deze Journey Stage"
          background-color="background"
          prepend-icon="info"
          persistent-hint
          required
        ></v-text-field>

        <div class="select-color-field clear">
          <label>Kleur</label>
          <div class="color-field">
            <swatches
              v-model="newStage.color"
              :colors="colors"
              :exceptions="exceptions"
              :wrapper-style="wrapperStyle"
              :swatch-style="swatchStyle"
              exception-mode="hidden"
              swatch-size="36"
              show-border
              inline
            ></swatches>
          </div>
          <div class="custom-hint">
            De kleur wordt weergegeven in de grafiek met resultaten
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewStageDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addStage()"
            >
              Stage toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";

export default {
  name: "add-stage-form",
  props: {
    activeComp: Object,
    activeJourney: Object,
    exceptions: Array,
    stages: Array,
  },
  components: { Swatches },

  data() {
    return {
      colors: [
        "#72D9C4",
        "#83C0EC",
        "#BC8DD0",
        "#F39488",
        "#F8DD65",
        "#E89861",
        "#61C1AD",
      ],
      wrapperStyle: { paddingTop: "0", paddingLeft: "0" },
      swatchStyle: { marginBottom: "0" },
      newStage: {
        name: "",
        description: "",
        color: null,
      },
      feedback: null,
    };
  },

  created() {
    bus.$on("setRandomStageColor", this.pickRandomColor);
  },

  methods: {
    closeNewStageDialog() {
      this.$emit("newStageDialogChange", false);
    },

    pickRandomColor() {
      let usedColors = this.exceptions;
      let colors = this.colors;
      let availableColors = colors.filter(function(obj) {
        return usedColors.indexOf(obj) == -1;
      });
      this.newStage.color =
        availableColors[Math.floor(Math.random() * availableColors.length)];
    },

    addStage() {
      if (
        this.newStage.name &&
        this.newStage.description &&
        this.newStage.color
      ) {
        const order = this.stages.length;
        db.collection("stages")
          .add({
            journeyId: this.activeJourney.id,
            name: this.newStage.name,
            description: this.newStage.description,
            color: this.newStage.color,
            order: order,
            compId: this.activeComp.id,
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action:
                  "Nieuwe Journey Stage toegevoegd: " + this.activeComp.name,
                extra:
                  "<b>Naam:</b> " +
                  this.newStage.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.newStage.description +
                  "<br>" +
                  "<b>Kleur:</b> " +
                  this.newStage.color,
              })
              .catch((error) => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewStageDialog();
            this.newStage.name = "";
            this.newStage.description = "";

            console.log("Stage succesfully added ");
          })
          .catch((error) => {
            console.error("Error adding Stage: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Stage: " + this.activeComp.name,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een stage toe te voegen";
      }
    },
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>
